export class DateHelper {
	public static toYYYYMMDDString(date: Date): string {
		const mm = date.getMonth() + 1;
		const dd = date.getDate();

		return [date.getFullYear(),
		(mm > 9 ? '' : '0') + mm,
		(dd > 9 ? '' : '0') + dd
		].join('-');
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/helpers/date-helper.ts